import React from 'react';
import _ from 'lodash';
import SparePartsFinderCheckboxListFilter from './SparePartsFinderCheckboxListFilter';

export default class SparePartsFinderCheckboxListSingleSelectFilter extends SparePartsFinderCheckboxListFilter {

    renderHeaderSelectAllOption = () => (
        <React.Fragment/>
    )

    onChange = value => {
        const model = this.props.model === value ? 0 : value;
        this.props.onFilterChange(this.props.meta.slug, model);
    }

    onClearClick = e => {
        this.props.onFilterChange(this.props.meta.slug, this.clear());
    }

    clear = () => 0;

    isChecked = o => this.props.selectedValues.includes(o.value);

    canRenderClearOption() {
        return this.props.selectedItem !== null;
    }
} 